import { createClient } from "@supabase/supabase-js";

const RESTClient = createClient(
    "https://npyuwmezccfrkctjczwm.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5weXV3bWV6Y2NmcmtjdGpjendtIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTE2MDEyMDMsImV4cCI6MjAwNzE3NzIwM30.0D2aSbgxniQUfmUGstoVUitD-KVD098Gq1yScilE-j0"
);

export default RESTClient;